import { createContext, useContext } from "react";

/**
 * Where the shared Radix primitives (dialog, popover, select, tooltip) portal
 * to.
 *
 * `null` (the default) keeps Radix's own default of `document.body`. A subtree
 * rendered into another window — the FloatingPanel pop-out (MDRS-486) — sets
 * this to an element inside that window, otherwise a dialog opened from the
 * pop-out would appear back in the main window.
 */
const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export const usePortalContainer = () => useContext(PortalContainerContext);
